import en from '../locales/en.json';

export const getLocalizedMessage = (key: string): string => {
    const translations = en;
    return translations[key] || key;
};